import { useEffect, useState } from 'react';

//El texto que se quiera introducir des de la feature app incorporando la posibilidad de editarlo
// en el fragmento de JSX donde se renderize debe figurar de la siguiente manera:
// <div dangerouslySetInnerHTML={useTransfomToHtml(string)}/>

export const useTransformToHtml = (text: string) => {
	return { __html: text };
};
